import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

import { MatButtonModule } from '@angular/material/button';
import { FilterComponent, FilterFieldConfig } from '../filter.component';


@Component({
  selector: 'app-filter-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    FilterComponent
],
  template: `
    <h2 mat-dialog-title>Pretraga</h2>
    <mat-dialog-content>
      <app-filter
        [filterScope]="data.filterScope"
        [filterConfig]="data.filterConfig"
        (filterChange)="onFilterChange($event)"
      ></app-filter>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">Odustani</button>
      <button mat-raised-button color="primary" (click)="onApply()">Primijeni</button>
    </mat-dialog-actions>
  `,
})
export class FilterDialogComponent {
  currentFilters: any = {};

  constructor(
    public dialogRef: MatDialogRef<FilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { 
      filterConfig: FilterFieldConfig[],
      filterScope: string; 
     }
  ) {}

  onFilterChange(values: any) {
    this.currentFilters = values;
  }

  onApply() {
    this.dialogRef.close(this.currentFilters);
  }

  onCancel() {
    this.dialogRef.close(null);
  }
}